import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)

const _getters = {}

const store = new Vuex.Store({
  state: {
      latestFarmers: []
  },
  mutations: {
    getLatestFarmers(state, farmers) {
        state.latestFarmers = farmers
      }
  },
  actions: {
    getLatestFarmers(context) {
      return new Promise((resolve, reject) => {
        axios.get(`${window.location.origin}/farmers/farmers.json`)
          .then(res => {
            context.commit('getLatestFarmers', res.data)
            resolve(res)
          })
          .catch(err => {
            console.log(err);
            reject(err)
          })
      })
    }
  },
  getters: _getters
})

export default store



// WEBPACK FOOTER //
// ./src/store.js